import { render } from "./The404Page.vue?vue&type=template&id=45c5c7e8"
const script = {}

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-cc52297f69/2/root/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__